import styled from '@emotion/styled/macro';
import vars from '@variables';
import { Link } from 'gatsby';

const sharedStyles = `
  text-decoration: none;
  width: 100%;
  background-color: white;
  border: 0;
  font-size: 1.8rem;
  padding: ${vars.spacingM} ${vars.spacingM};
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:first-of-type {
    margin-top: ${vars.spacingL};
  }

  span {
    font-weight: ${vars.fontWeightMedium};
  }
`;

export const StyledExternalLink = styled.a`
  ${sharedStyles}
`;
export const StyledLink = styled(Link)`
  ${sharedStyles}
`;
